export default __webpack_public_path__ + "static/media/sallers.466d7b88.png";